import {handleRes} from './handle_res'
import {getParams} from './helpers'
import {destroyLocal} from './local_record_actions'
import {backendKind} from '../record_building/record_keys'
import {api as backend} from '../backend'
import {config} from '../config'

async function add(kind, params, {url = '', extraParams = {}, local = true, localKind, ...rest} = {}) {
	kind = backendKind(kind)
	const isCreate = !params['id']
	const meth = isCreate ? backend.post : backend.put
	const standardUrl = isCreate ? `${kind}/${url}` : `${kind}/${params.id}${url}`
	const obj = getParams(kind, params)

	const urls = isCreate ? config.createUrls : config.updateUrls
	const _url = urls[kind] ? urls[kind](params['id']) : standardUrl

	const finalParams = {...obj, ...extraParams}
	const res = await meth(_url, finalParams, rest)
	if (!local) return res
	const actKind = localKind || kind // TODO check how we want to fix this
	return handleRes(res, actKind, params)
}

export const create = add
export const update = add

export async function updateMulti(kind, params, {extraParams} = {}) {
	const res = await backend.post(`${kind}/multi_update`, {
		items: params,
		...extraParams,
	})
	return handleRes(res, kind)
}

export async function destroy(kind, id, extraParams = {}) {
	const url = `${kind}/${id}`
	const res = await backend.delete(url)
	if (res.ok && res.data && !res.data.destroyed_ids && !res.data.items) {
		destroyLocal(kind, id, extraParams)
		return {ok: true}
	} else {
		return handleRes(res, kind, {id})
	}
}

// TODO added since we are using it quite often, check if this is desired
export async function updateAssoc(kind, params = {}, {extraParams = {}, add = true} = {}) {
	const obj = getParams(kind, params)
	const endPoint = add ? 'assoc' : 'remove_assoc'
	const url = `${kind}/${params.id}/${endPoint}`
	const res = await backend.put(url, obj)
	return handleRes(res, kind, params)
}

export async function removeAssoc(kind, params, rest = {}) {
	return updateAssoc(kind, params, {...rest, add: false})
}

export async function addAssoc(kind, params = {}, rest = {}) {
	return updateAssoc(kind, params, {...rest, add: true})
}
